var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c('div',{staticClass:"payline"},[_c('grid',{staticClass:"pb-2",attrs:{"config":_vm.config,"cell-size":_vm.cellSize,"disabled":!_vm.enabled,"classes":_vm.classes,"labels":_vm.labels},on:{"select":_vm.toggleIndex}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }